export const environment ={
    api: "https://api.esfershop.com/dev/account-manager"
}
